

























































































































































































































































import ContentCreator from '@/components/simpleSlide/components/ContentCreator.vue';
import deck from '@/store/modules/deck';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import TypedPages from '@/components/simpleSlide/components/TypedPages.vue';
import Preview from '@/components/simpleSlide/components/Preview.vue';
import FinancialMentionField from '@/components/simpleSlide/components/FinancialMentionField.vue';

@Component({
  components: { TypedPages, ContentCreator, Preview, FinancialMentionField },
})
export default class SlideContent extends Vue {
  @Prop() readonly slide: any;
  @Prop() readonly slideIndex!: number;

  slideTemplate: string = '';
  orgNr: string = '';
  sieAggVersion: string = '';
  requiresCompany: boolean = true;
  customSubtitle: boolean = false;
  contentChoiceStep: 'root' | 'content' = 'root';

  // Förhandsvisningar i valet av sidtyp
  get previewSlideHeadline() {
    return {
      slideType: 'slideHeadline',
      title: 'Rubrik',
      comment: '',
    };
  }

  get previewSlideContent() {
    return {
      slideType: 'slideContent',
      contentType: 'contentList',
      comment: '',
      subSlides: [
        {
          id: 1,
          description: 'Flik 1',
          contentType: 'contentList',
          items: ['Punkt 1', 'Punkt 2', 'Punkt 3'],
        },
      ],
    };
  }

  get previewSlideContentTabs() {
    return {
      slideType: 'slideContent',
      comment: '',
      subSlides: [
        {
          id: 1,
          description: 'Flik 1',
          contentType: 'contentList',
          items: ['Punkt 1', 'Punkt 2', 'Punkt 3'],
        },
        { id: 2, description: 'Flik 2', contentType: '' },
        { id: 3, description: 'Flik 3', contentType: '' },
        { id: 4, description: 'Flik 4', contentType: '' },
      ],
    };
  }

  get previewSlideFullContent() {
    return {
      slideType: 'slideFullContent',
      comment: '',
      subSlides: [
        {
          id: 1,
          description: '',
          contentType: 'contentTeam',
          title: 'Ditt team',
          teamMembers: [
            {
              name: 'Jenny',
              role: 'Partner',
              staticImagePath: '/static/common/image/teammembers/Jenny.png',
            },
            {
              name: 'Joel',
              role: 'Manager',
              staticImagePath: '/static/common/image/teammembers/Joel.png',
            },
            {
              name: 'Jasmine',
              role: 'Assistant',
              staticImagePath: '/static/common/image/teammembers/Jasmine.png',
            },
          ],
        },
      ],
    };
  }

  get previewSplitContent() {
    return {
      slideType: 'splitContent',
      comment: '',
      subSlides: [
        {
          id: 1,
          description: '',
          contentType: 'contentList',
          items: ['Punkt 1', 'Punkt 2', 'Punkt 3'],
        },
        {
          id: 2,
          description: 'Nettoomsättning',
          contentType: 'contentChart',
          chart: 'turnover',
        },
      ],
    };
  }

  get previewSlideTypedPages() {
    return {
      // Efterlikna en färdig sida av typen "profitlossOverview"
      slideType: 'slideContent',
      template: 'profitlossOverview',
      comment: '',
      subSlides: [
        {
          id: 1,
          contentType: 'contentList',
          description: 'Resultatöversikt',
          items: [
            'Omsättning på 10 Mkr',
            'Stabil marginal senaste året',
            'Positiv resultatutveckling',
          ],
        },
        {
          id: 2,
          contentType: 'contentChart',
          chart: 'turnover',
          description: 'Nettoomsättning',
        },
        {
          id: 3,
          contentType: 'contentChart',
          chart: 'operatingMargin',
          description: 'Rörelsemarginal',
        },
        {
          id: 4,
          contentType: 'contentChart',
          chart: 'profitloss',
          description: 'Senaste året',
        },
      ],
    };
  }

  @Watch('slide', { immediate: true, deep: true })
  onSlideUpdated() {
    if (this.slide.slideType === 'slideTitle') {
      if (deck.OrgNr === '00') {
        // this.slide.subtitle = '';
        // this.update();
      } else {
        this.customSubtitle = this.slide.customSubtitle || false;
        const subTitle = deck.OrgName || '';
        if (!this.slide.customSubtitle && this.slide.subtitle !== subTitle) {
          this.slide.subtitle = subTitle;
          this.update();
        }
      }
    }
  }

  @Watch('customSubtitle', { immediate: false, deep: true })
  onCustomSubtitleUpdated() {
    if (this.slide.slideType === 'slideTitle') {
      this.slide.customSubtitle = this.customSubtitle;
      this.update();
    }
  }

  setSlideType(slideType: string) {
    let slide = this.slide;
    switch (slideType) {
      case 'slideHeadline':
        slide = {
          slideType,
          comment: '',
          title: 'Rubrik',
        };
        break;
      case 'slideContent':
        slide = {
          slideType,
          comment: '',
          subSlides: [{ id: 1, description: '', contentType: '' }],
        };
        break;
      case 'slideFullContent':
        slide = {
          slideType,
          comment: '',
          subSlides: [{ id: 1, description: '', contentType: '' }],
        };
        break;
      case 'splitContent':
        slide = {
          slideType,
          comment: '',
          subSlides: [
            { id: 1, description: '', contentType: '' },
            { id: 2, description: '', contentType: '' },
          ],
        };
        break;
      case 'typedPages':
        slide = {
          slideType,
          comment: '',
        };
        break;
      case 'reset':
        deck.setCurrentSubSlide(0);
        slide = {
          slideType: null,
          comment: '',
        };
        this.contentChoiceStep = 'root';
        break;
    }

    deck.updateSlide({
      slide,
      index: this.slideIndex,
    });
  }

  backToDesign() {
    deck.setCurrentSubSlide(0);
    this.contentChoiceStep = 'content';
    deck.updateSlide({
      slide: {
        slideType: null,
        comment: '',
      },
      index: this.slideIndex,
    });
  }

  async setSlideByTemplate(template: string) {
    const id = parseInt(this.sieAggVersion, 10);
    if (this.orgNr !== '') {
      await deck.loadData({
        orgNr: this.orgNr,
        sieAggVersion: id,
        internal: false,
      });
    }
    await deck.setSlideByTemplate({
      template,
      orgNr: this.orgNr,
      sieAggVersion: id,
      index: this.slideIndex,
    });
  }

  update() {
    deck.updateSlide({
      slide: this.slide,
      index: this.slideIndex,
    });
  }

  get mentionCompanyData(): any | null {
    const orgNr = deck.OrgNr;
    if (!orgNr || orgNr === '00') {
      return null;
    }
    const byOrg = deck.Data && deck.Data[orgNr];
    if (!byOrg) {
      return null;
    }
    const sie = deck.SieAggVersion || 0;
    return byOrg[sie] || byOrg[0] || null;
  }

  onTitleMention(value: string) {
    this.slide.title = value;
    this.update();
  }

  onSubtitleMention(value: string) {
    this.slide.subtitle = value;
    this.update();
  }

  get slides() {
    return deck.Slides;
  }

  get deck() {
    return deck;
  }
}
